import { useEffect } from 'react'
import ChartService from '../services/chart.service'

const useGetUserConnectionsPerMonth = (user_name, data, setData) => {       
    useEffect(()=> {

        const getData = async (userName) => {
            try {
                const serviceResponse = await ChartService.getUserConnectionsPerMonth(userName);
                const response = serviceResponse.data;

                const data = {
                    dates: response.data.map(({ dt }) => dt),
                    values: response.data.map(({ count }) => count)
                }

                setData(data);
            }
            catch (error) {
            }
        }

        if (user_name !== null && data === null) {
            getData(user_name)
        }
    
    }, [user_name, data, setData]);
}
const useGetUserConnectionsPerYear = (user_name, data, setData) => {       
    useEffect(()=> {

        const getData = async (userName) => {
            try {
                const serviceResponse = await ChartService.getUserYearConnections(userName);
                const response = serviceResponse.data;

                const data = {
                    dates: response.data.map(({ dt }) => dt),
                    values: response.data.map(({ count }) => count)
                }

                setData(data);
            }
            catch (error) {
            }
        }

        if (user_name !== null && data === null) {
            getData(user_name)
        }
    
    }, [user_name, data, setData]);
}

const useGetClientConnectionsPerMonth = (client_id, data, setData) => {       
    useEffect(()=> {
        const getData = async (clientId) => {
            try {
                const serviceResponse = await ChartService.getClientConnectionsPerMonth(clientId);
                const response = serviceResponse.data;

                if (response.data.length > 0) {
                    const data = {
                        dates: response.data[0].data.map(({ date }) => date),
                        values: response.data[0].data.map(({ count }) => count)
                    }
    
                    setData(data);           
                }
            }
            catch (error) {
                setData([]);           
            }
        }

        if (client_id !== null && data === null) {
            getData(client_id)
        }
    
    }, [client_id, data, setData]);
}
const useGetClientConnectionsPerYear = (client_id, data, setData) => {       
    useEffect(()=> {
        const getData = async (clientId) => {
            try {
                const serviceResponse = await ChartService.getClientConnectionsPerMonth(clientId);
                const response = serviceResponse.data;

                if (response.data.length > 0) {
                    const data = {
                        dates: response.data[0].data.map(({ date }) => date),
                        values: response.data[0].data.map(({ count }) => count)
                    }
    
                    setData(data);           
                }
            }
            catch (error) {
            }
        }

        if (client_id !== null && data === null) {
            getData(client_id)
        }
    
    }, [client_id, data, setData]);
}


const useGetClientConnectionByCompanyType = (client_id, data, setData) => {       
    useEffect(()=> {
        const getData = async (clientId) => {
            try {
                const serviceResponse = await ChartService.getClientConnectionByCompanyType(clientId);
                const response = serviceResponse.data;

                if (response.data.length > 0) {
                    setData(response.data);
                }
            }
            catch (error) {
                setData([]);
            }
        }

        if (client_id !== null && data === null) {
            getData(client_id)
        }
    
    }, [client_id, data, setData]);
}
const useGetAllClientConnectionsPerMonth = (chartData, setData) => {       
    useEffect(()=> {
        const getData = async () => {
            try {
                const serviceResponse = await ChartService.getAllClientYearConnections();
                const response = serviceResponse.data;

                if (response.data.length > 0) {
                    const data = {
                        seriesBarChart: response.data.map((item, index) => { return {
                            name: item.client,
                            data: item.data.map(({count}) => count)
                        }}),
                        seriesPieChart: response.data.map(({count}) => count),
                        categoriesPieChart: response.data.map(({client}) => client),
                        categoriesBarChart: [...new Set([].concat(...Object.values(response.data).map((item) => { return item.data.map(({date}) => date) })))]
                    }
                    setData(data);           
                }
            }
            catch (error) {
                setData([]);
            }
        }

        if (chartData === null) {
            getData()
        }
    
    }, [chartData, setData]);
}

const useGetAllClientUserCount = (chartData, setData) => {       
    useEffect(()=> {
        const getData = async () => {
            try {
                const serviceResponse = await ChartService.getAllClientUserCount();
                const response = serviceResponse.data;

                if (response.data.length > 0) {
                    const data = {
                        series: response.data.map(({count}) => count),
                        categories: response.data.map(({client}) => client),
                    }
                    setData(data);           
                }
            }
            catch (error) {
            }
        }

        if (chartData === null) {
            getData()
        }
    
    }, [chartData, setData]);
}
  
const useGetAllClientRoleCount = (chartData, setData, selectedFilterClientId) => {       
    useEffect(()=> {
        const getData = async () => {
            try {
                const serviceResponse = await ChartService.getAllClientRoleCount(selectedFilterClientId);
                const response = serviceResponse.data;

                if (response.data.length > 0) {
                    const data = {
                        series: response.data.map(({count}) => count),
                        categories: response.data.map(({role}) => role),
                    }
                    setData(data);           
                }
            }
            catch (error) {
            }
        }

        if (chartData === null) {
            getData()
        }
    
    }, [chartData, setData, selectedFilterClientId]);
}

const useGetUserPermission = (user_name, userPermissions, setUserPermissions) => {       
    useEffect(()=> {

        const getUserPermission = async (userName) => {

            try {
                const serviceResponse = await ChartService.getUserPermission(userName);
                const response = serviceResponse.data;
                
                if (response.succeeded) {
                    setUserPermissions(response.data);
                }
                else {
                    setUserPermissions([]);
                }
            }
            catch (error) {
                setUserPermissions([]);
            }
        }

        if (user_name !== null && userPermissions === null) {
            getUserPermission(user_name)
        }
    
    }, [user_name, userPermissions, setUserPermissions]);
}

const useGetAllClientLAstMonthConnections = (chartData, setData) => {       
    useEffect(()=> {
        const getData = async () => {
            try {
                const serviceResponse = await ChartService.getAllClientLAstMonthConnections();
                const response = serviceResponse.data;

                if (response.data.length > 0) {
                    setData(response.data);           
                }
            }
            catch (error) {
            }
        }

        if (chartData === null) {
            getData()
        }
    
    }, [chartData, setData]);
}

export {
    useGetUserConnectionsPerMonth,
    useGetUserConnectionsPerYear,
    useGetClientConnectionsPerMonth,
    useGetClientConnectionsPerYear,

    useGetClientConnectionByCompanyType,

    useGetAllClientConnectionsPerMonth,
    useGetAllClientUserCount,
    useGetAllClientRoleCount,
    useGetUserPermission, 
    useGetAllClientLAstMonthConnections,
}